<template>
  <div class="wrapper">
    <spacer :y="10"/>
    <h2 :class="$style.title">ログイン</h2>
    <spacer :y="4"/>
    <form
      v-on:submit="submit"
      v-bind:class="user.login.vibration ? $style.vibration : ''"
      autocomplete="off">
      <div :class="$style.form">
        <div :class="$style.input">
          <input
            id="mail"
            type="email"
            name="mail"
            placeholder="メールアドレスを入力"
            v-model.trim="$v.mail.$model"
            v-bind:class="{ input_error: validationFlags.mail }"
            v-on:input="invalidsCheck('mail', $v.mail.$invalid)"
            >
          <span :class="$style.slideIn"/>
        </div>
        <p
          :class="$style.comment"
          v-if="$v.mail.$dirty
            && $v.mail.required.$invalid">メールアドレスを入力してください</p>
        <p
          :class="$style.comment"
          v-if="$v.mail.$dirty
            && $v.mail.email.$invalid">正しいメールアドレスの形式で入力してください</p>
        <spacer :y="1.5"/>
        <div :class="$style.input">
          <input
            id="password"
            type="password"
            name="password"
            placeholder="パスワードを入力"
            v-model.trim="$v.password.$model"
            v-bind:class="{ input_error: validationFlags.password }"
            v-on:input="invalidsCheck('password', $v.password.$invalid)"
            >
          <span :class="$style.slideIn" />
        </div>
        <p
          :class="$style.comment"
          v-if="$v.password.$dirty
            && $v.password.required.$invalid">パスワードを入力してください</p>
        <spacer
          v-if="user.login.isBanned || user.login.isFailed >= 1"
          :y="3"/>
        <p
          :class="$style.message"
          v-if="user.login.isBanned">パスワードを5回間違えたため、{{ user.login.unbannedTime }}までログインが制限されています。<br>制限を解除したい場合は運営まで連絡してください。</p>
        <p
          :class="$style.comment"
          v-if="user.login.isFailed === 1 && !user.login.isBanned">入力されたメールアドレスは登録されていません</p>
        <p
          :class="$style.comment"
          v-if="user.login.isFailed === 2 && !user.login.isBanned">入力されたパスワードが間違っています</p>
        <spacer :y="3"/>
          <BasicBtn
            :class="$style.customBtn"
            width="full"
            v-bind:disabled="!submitFlag">ログイン</BasicBtn>
          <!-- <spacer :y="2"/>
          <BasicBtn :class="$style.customBtn" tag="a" link="/signup/" width="full" type="bdr">新規会員登録</BasicBtn> -->
        <spacer :y="3"/>
        <div :class="$style.wrap" style="flex-direction: column">
          <div :class="$style.forgot">
            <router-link
              to="/forgot-password/">パスワードをお忘れですか？</router-link>
          </div>
        </div>
      </div>
    </form>
    <spacer :y="15"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import cf from '@/mixins/commonFunctions';
import { Spacer, BasicBtn } from '@/components/parts';

export default {
  name: 'Login',
  mixins: [cf],
  components: {
    Spacer,
    BasicBtn,
  },
  data() {
    return {
      validationFlags: {
        mail: false,
        password: false,
      },
      invalids: {
        mail: true,
        password: true,
      },
      isExpired: false,
    };
  },
  created() {
    this.axios({
      method: 'GET',
      url: '/v1/connection/test',
    })
      .then((response) => {
        console.log(response.data.status);
      })
      .catch((error) => {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      });

    if (this.$route.query
      && this.$route.query.expired) this.isExpired = true;
  },
  setup() {
    const mail = ref('');
    const password = ref('');

    const rules = {
      mail: { required, email },
      password: { required },
    };

    const $v = useVuelidate(rules, { mail, password });

    return { mail, password, $v };
  },
  computed: {
    ...mapState(['user', 'page', 'helper']),
    submitFlag() {
      return !this.invalids.mail && !this.invalids.password;
    },
  },
  methods: {
    invalidsCheck(name, bool) {
      this.invalids[name] = bool;
    },

    submit(e) {
      e.preventDefault();

      const data = {
        email: this.mail,
        password: this.password,
      };

      this.$store.dispatch('user/login/submit', data);
      this.$store.dispatch('user/update');
    },
  },
};
</script>

<style lang="scss" module>
body {
  font-family: 'bold', '游ゴシック体', 'Yu Gothic', 'ヒラギノ角ゴ Pro';
  font-weight: bold;
}
.customBtn {
  max-width: 400px;
  margin: 0 auto;
  color: #fff;
}
.wrap {
  display: flex;
  justify-content: center;
}
.logo {
  margin: 0 auto;
  width: 50%;
  max-width: 300px;
}
.title {
  text-align: center;
  color: var(--orange-main);
}
.form {
  text-align: center;
}
.input {
  margin: 0 auto;
  width: 400px;
  max-width: 100%;
  display: flex;
  align-items: center;
  font-size: 20px;
  input {
    width: 100%;
    padding: 20px;
    border: none;
    background-color: #ffffff;
    outline: none;
    border: 2px solid rgba(152, 121, 89, 1);
    border-radius: 15px;

    &:focus + .slideIn {
      display: block;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(#e2e2e2, .4);
      mix-blend-mode: multiply;
      position: absolute;
      animation: split .3s;
    }

    @keyframes split {
      0% {
        width: 0;
      }
      100% {
        width: 100%;
      }
    }
  }
}
.comment {
  font-size: 12px;
  color: var(--pink);
}
.message {
  font-size: 14px;
  text-align: center;
}
.btn {
  border: none;
  background-color: #666;
  color: #fff;
}
.lgnlink {
  border: 1px solid rgb(26, 34, 61);
  color: rgb(26, 34, 61);
  background-color: #fff;
  text-decoration: none;
  &:hover {
    color: inherit
  }
}

.btn,.lgnlink {
  display: inline-block;
  border-radius: 22px;
  appearance: none;
  padding: 8px 25px;
  font-size: 16px;
  font-weight: bold;
}

.forgot {
  font-size: 14px;
  text-decoration: underline;
  a {
    color: var(--orange-main);
  }
}

// ログイン失敗時
.vibration {
  animation: vibration .1s  infinite;
}
@keyframes vibration {
  0% {transform: translate(0px, 0px) rotateZ(0deg)}
  25% {transform: translate(2px, 2px) rotateZ(1deg)}
  50% {transform: translate(0px, 2px) rotateZ(0deg)}
  75% {transform: translate(2px, 0px) rotateZ(-1deg)}
  100% {transform: translate(0px, 0px) rotateZ(0deg)}
}
</style>
